/**
 * 网络请求配置
 */
import axios from "axios";
import md5 from 'js-md5';

axios.defaults.timeout = 100000;
// axios.defaults.baseURL = "http://192.168.3.50:12000/pipi-snailcar-server";
// 海外用.com
// axios.defaults.baseURL = "https://www.snailcle.com/pipi-snailcar-server";
// 国内用.cn
axios.defaults.baseURL = "https://www.snailcle.cn/pipi-snailcar-server";

/**
 * http request 拦截器
 */
// axios.interceptors.request.use(
//   (config) => {

//     var now = new Date().getTime()
//     var nonce = randomNum(12)
//     nonce += now
//     var sing = md5('web' + '3gh827773b405c8ac7a8fb9' + '' + now + nonce)
//     const headerCon = {
//       'appId': 'web',
//       'sign': sing,
//       'timestamp': now,
//       'nonce': nonce,
//     }

//     config.data = JSON.stringify(config.data);
//     config.headers = {
//       ...headerCon
//     };
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

/**
 * http response 拦截器
 */
axios.interceptors.response.use(
  (response:any) => {
    if (response.data.errCode === 2) {
      console.log("过期");
    }
    return response;
  },
  (error: Error) => {
    console.log("请求出错：", error);
  }
);

/**
 * 封装get方法
 * @param url  请求url
 * @param params  请求参数
 * @returns {Promise}
 */
export function get(url: string, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
        params: params,
      }).then((response:any) => {
        landing(url, params, response.data);
        resolve(response.data);
      })
      .catch((error:any) => {
        reject(error);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url: string, data: Object,options: any = {}) {
  var now = new Date().getTime()
    var nonce = randomNum(12)
    nonce += now
    var sing = md5('web' + '3gh827773b405c8ac7a8fb9' + '' + now + nonce)
    const headerCon = {
      'appId': 'web',
      'sign': sing,
      'timestamp': now,
      'nonce': nonce,
      "Content-Type": "application/json",
    }

  return new Promise((resolve, reject) => {
    axios.post(url, data,{...options,headers: {
      ...headerCon,
      ...options?.headers
    }}).then(
      (response: any) => {
        //关闭进度条
        resolve(response.data);
      },
      (err:any) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function patch(url: string, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      (response:any) => {
        resolve(response.data);
      },
      (err: Error) => {
        msag(err);
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url:any, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      (response:any) => {
        resolve(response.data);
      },
      (err: Error) => {
        msag(err);
        reject(err);
      }
    );
  });
}

//统一接口处理，返回数据
export default function (fecth:any, url:any, param:any) {
  let _data = "";
  return new Promise((resolve, reject) => {
    switch (fecth) {
      case "get":
        console.log("begin a get request,and url:", url);
        get(url, param)
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            console.log("get request GET failed.", error);
            reject(error);
          });
        break;
      case "post":
        post(url, param)
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            console.log("get request POST failed.", error);
            reject(error);
          });
        break;
      default:
        break;
    }
  });
}

//失败提示
function msag(err:any) {
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        alert(err.response.data.error.details);
        break;
      case 401:
        alert("未授权，请登录");
        break;

      case 403:
        alert("拒绝访问");
        break;

      case 404:
        alert("请求地址出错");
        break;

      case 408:
        alert("请求超时");
        break;

      case 500:
        alert("服务器内部错误");
        break;

      case 501:
        alert("服务未实现");
        break;

      case 502:
        alert("网关错误");
        break;

      case 503:
        alert("服务不可用");
        break;

      case 504:
        alert("网关超时");
        break;

      case 505:
        alert("HTTP版本不受支持");
        break;
      default:
    }
  }
}

/**
 * 查看返回的数据
 * @param url
 * @param params
 * @param data
 */
function landing(url:any, params:any, data:any) {
  if (data.code === -1) {
  }
}
function randomNum (n:any) {
  var str = ['0','1','2','3','4','5','6','7','8','9'];
  var res = "";
  for(var i = 0; i < n ; i ++) {
    var id = Math.ceil(Math.random()*9);
    res += str[id];
  }
  return res;
}
